document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 1200) {
        const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
        const mobileMenuClose = document.querySelector('.mobile-menu-close');
        let isDropdownOpen = false;

        dropdownToggles.forEach(function (toggle) {
            toggle.addEventListener('click', function (event) {
                const dropdownMenu = this.nextElementSibling;

                const isMenuOpen = dropdownMenu.classList.contains('show');

                closeAllDropdowns();

                const mobileMenuSearchbar = document.querySelector('.mobile-menu-searchbar');

                if (isMenuOpen) {
                    mobileMenuClose.classList.remove('active');
                    mobileMenuSearchbar.classList.remove('active');
                    this.setAttribute('aria-expanded', 'false');
                } else {
                    mobileMenuClose.classList.add('active');
                    mobileMenuSearchbar.classList.add('active');
                    this.setAttribute('aria-expanded', 'true');
                }

                dropdownMenu.classList.toggle('show');

                if (isMenuOpen && isDropdownOpen) {
                    const href = this.getAttribute('href');
                    if (href) {
                        event.preventDefault();
                        window.location.href = href;
                    }
                }

                isDropdownOpen = !isDropdownOpen;
            });
        });

        function closeAllDropdowns() {
            const openMenus = document.querySelectorAll('.dropdown-menu.show');
            openMenus.forEach(function (menu) {
                menu.classList.remove('show');
                const toggle = menu.previousElementSibling;
                toggle.setAttribute('aria-expanded', 'false');
            });
        }

        mobileMenuClose.addEventListener('click', function () {
            const openMenu = document.querySelector('.dropdown-menu.show');
            if (openMenu) {
                openMenu.classList.remove('show');
                mobileMenuClose.classList.remove('active');
                document.querySelector('.mobile-menu-searchbar').classList.remove('active');
                dropdownToggles.forEach(function (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                });
            }
        });
    }
});